import PatcraftApi from "../../../scripts/patcraft-api";
import gtm from "../../../gtm-event-helper.js";

const state = () => ({
  basket: [],
  // availableBasket: ["SiteItems", "TrayItems"],
  saveForLater: [],
  saveForLaterData: {},
  loader: false,
  checkOut: {
    isSameAddress: null,
    currentCheckOutType: null
  },
  MaxCartLimit: [],
  fullTypeSizeSamples: [],
  ideaBookFlag: false
});

// Getters
const getters = {
  getBasketItems: state => {
    if (state.basket.SiteItems) {
      state.basket.SiteItems.forEach((e, index) => {
        let isFullSize = state.fullTypeSizeSamples.find(
          ({ Key, Value }) => Key === e.VehicleId && Value === true
        );
        let checkVehicleId = e.SampleSizes.find(
          ({ Value }) => Value == e.VehicleId
        );
        if (!checkVehicleId) {
          state.basket.SiteItems[index].VehicleId = "";
        }
        if (isFullSize && !state.basket.IsTrustedUser) {
          if(state.basket.SiteItems[index].SampleAvailability > state.MaxCartLimit.maxfullsizeitems) {
            state.basket.SiteItems[index].SampleAvailability =
            state.MaxCartLimit.maxfullsizeitems;
          }
        }
      });
    }
    return state.basket;
  },
  getSaveForLater: state => {
    return state.saveForLater;
  },
  getLoader: state => {
    return state.loader;
  },
  getCheckOutType: state => {
    return state.checkOut;
  },
  getBasketCount: state => {
    let result = {
      siteItems:
        state.basket && state.basket.SiteItems
          ? state.basket.SiteItems.reduce(
              (accumulator, currentValue) =>
                accumulator + currentValue.Quantity,
              0
            )
          : 0,
      trayItems:
        state.basket && state.basket.TrayItems
          ? state.basket.TrayItems.reduce(
              (accumulator, currentValue) =>
                accumulator + currentValue.Quantity,
              0
            )
          : 0
    };
    return result;
  },
  getQuantityValidation: state => {
    if (state.basket && state.basket.SiteItems) {
      let check = state.basket.SiteItems.find(
        e => e.Quantity > e.SampleAvailability
      );
      return check ? true : false;
    }
    return false;
  },
  getSampleSizeValidation: state => {
    if (state.basket && state.basket.SiteItems) {
      let check = state.basket.SiteItems.find(
        e => e.SampleSizes.length == 0 || !e.VehicleId
      );
      if (check) {
        return true;
      }
    }
    if (state.basket && state.basket.TrayItems) {
      let check = state.basket.TrayItems.find(
        e => e.SampleSizes.length == 0 || !e.VehicleId
      );
      if (check) {
        return true;
      }
    }
    return false;
  },
  getFullTypeSizeSamples: state => {
    return state.fullTypeSizeSamples;
  },
  getIdeaBookFlag: state => {
    return state.ideaBookFlag;
  }
};

// Mutations
const mutations = {
  setBasketItem(state, { results }) {
    results["SiteItems"].forEach((element, index) => {
      let vehicleId = element.VehicleId;
      let selectedSize = element["SampleSizes"].find(
        ({ Value }) => Value === vehicleId
      );
      if (selectedSize) {
        results["SiteItems"][index]["isVehicleIdMatch"] = true;
      } else {
        results["SiteItems"][index]["isVehicleIdMatch"] = false;
      }
    });
    state.basket = results;
    if (state.checkOut.isSameAddress === null) {
      state.checkOut.isSameAddress =
        state.basket.SiteItems &&
        state.basket.SiteItems.length > 0 &&
        state.basket.TrayItems &&
        state.basket.TrayItems.length > 0
          ? true
          : false;
    }
    let totalSiteItems =
      state.basket && state.basket.SiteItems
        ? state.basket.SiteItems.reduce(
            (accumulator, currentValue) => accumulator + currentValue.Quantity,
            0
          )
        : 0;
    let totalTrayItems =
      state.basket && state.basket.TrayItems
        ? state.basket.TrayItems.reduce(
            (accumulator, currentValue) => accumulator + currentValue.Quantity,
            0
          )
        : 0;
    let totalCount = totalSiteItems + totalTrayItems;
    let type = 1;
    let cartCountElement = document.getElementsByClassName(
      "nav-top-customer-link-with-number-indicator"
    )[0];
    if (!cartCountElement) {
      type = 0;
      cartCountElement = document.getElementsByClassName(
        "nav-top-customer-link-with-number-indicator-empty"
      )[0];
    }

    if (totalCount > 0) {
      cartCountElement.classList.add(
        "nav-top-customer-link-with-number-indicator"
      );
      cartCountElement.classList.remove(
        "nav-top-customer-link-with-number-indicator-empty"
      );
    } else {
      cartCountElement.classList.add(
        "nav-top-customer-link-with-number-indicator-empty"
      );
      cartCountElement.classList.remove(
        "nav-top-customer-link-with-number-indicator"
      );
    }
    cartCountElement.innerHTML = totalCount;
  },
  setSaveForLaterItems(state, { results }) {
    results.forEach((element, index) => {
      let selectedSize = element["SampleSizes"].find(
        ({ Selected }) => Selected === true
      );
      if (selectedSize) {
        results[index]["SelectedSample"] = selectedSize;
      } else {
        results[index]["SelectedSample"] = results[index].SampleSizes[0];
      }
    });
    state.saveForLater = results;
  },
  setSizeSaveForLaterItems(state, { data }) {
    state.saveForLater[data[0]].VehicleId = data[1].vehicleId;
  },
  updateBasketItem(state, { res }) {
    let results = res.data.Data;
    results["SiteItems"].forEach((element, index) => {
      let vehicleId = element.VehicleId;
      let selectedSize = element["SampleSizes"].find(
        ({ Value }) => Value === vehicleId
      );
      if (selectedSize) {
        results["SiteItems"][index]["isVehicleIdMatch"] = true;
      } else {
        results["SiteItems"][index]["isVehicleIdMatch"] = false;
      }
    });
    state.basket = results;
  },
  updateLoader(state, data) {
    state.loader = data === true ? state.loader + 1 : state.loader - 1;
  },
  setAddressShipping(state, { data }) {
    state.checkOut.isSameAddress = data.checkoutType == "Mixed" ? true : false;
  },
  currentCheckOutType(state, { results }) {
    state.checkOut.currentCheckOutType = results.checkoutType;
  },
  setMaxCartLimit(state, result) {
    state.MaxCartLimit = result;
  },
  setFullTypeSizeSamples(state, { result }) {
    state.fullTypeSizeSamples = result;
  },
  setIdeaBookFlag(state, data) {
    state.ideaBookFlag = data;
  }
};

// Actions
const actions = {
  fetchBasketItem({ commit }, data) {
    commit("updateLoader", true);
    PatcraftApi.getBasketData(data)
      .then(res => {
        commit("setBasketItem", { results: res.data });
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        commit("updateLoader", false);
      });
  },
  fetchSaveForLaterItems({ commit }, data) {
    commit("updateLoader", true);
    PatcraftApi.getSaveForLaterBasket(data)
      .then(res => {
        commit("setSaveForLaterItems", { results: [...res.data] });
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        commit("updateLoader", false);
      });
  },
  updateMaxCartLimit({ commit, state }, data) {
    commit("setMaxCartLimit", data);
  },
  updateSizeSaveForLaterItems({ commit, state }, data) {
    commit("updateLoader", true);
    if (data.vehicleId) {
      PatcraftApi.updateSaveForLaterBasket(data)
        .then(res => {})
        .catch(error => {})
        .finally(() => {
          commit("updateLoader", false);
        });
    }
    let result = state.saveForLater.findIndex(
      ({ InventoryStyleNumber, SellingStyleNumber }) =>
        InventoryStyleNumber === data.inventoryStyleNumber &&
        SellingStyleNumber === data.sellingStyleNumber
    );
    if (result >= 0) {
      commit("setSizeSaveForLaterItems", { data: [result, data] });
    }
  },
  postBasket({ commit, dispatch, state }, data) {
    commit("updateLoader", true);
    PatcraftApi.postBasket(data.item)
      .then(res => {
        if (data.item.RequestAction == "update") {
          commit("updateBasketItem", { res });
        } else {
          if (data.item.RequestAction == "save") {
            dispatch("fetchSaveForLaterItems", null);
          }
        }
      })
      .catch(error => {})
      .finally(() => {
        dispatch("fetchBasketItem", data.basketName);
        commit("updateLoader", false);
      });
  },
  updateShippingAddress({ commit }, data) {
    PatcraftApi.shippingAddressUpdate(data)
      .then(() => {
        commit("setAddressShipping", { data });
      })
      .catch(() => {});
  },
  loader({ commit }, data) {
    commit("updateLoader", data);
  },
  clearBasketItems({ commit }, data) {
    commit("updateLoader", true);
    PatcraftApi.clearBasketItems(data)
      .then(res => {
        commit("setBasketItem", { results: res.data });
      })
      .catch(error => {})
      .finally(() => {
        commit("updateLoader", false);
      });
  },
  checkOutPost({ commit, dispatch, state }, data) {
    commit("updateLoader", true);
    if (
      state.basket.SiteItems.length > state.MaxCartLimit.maxallowedcartitems
    ) {
      dispatch(
        "notifications/add",
        {
          type: "error",
          title: "Error",
          description: this._vm.$resourceString["basket.MaxAllowedCartitems"]
        },
        { root: true }
      );
      commit("updateLoader", false);
      return;
    }
    if (state.ideaBookFlag) {
      data.declineAddIdeaBook = false;
      data.addIdeaBook = true;
    } else {
      data.declineAddIdeaBook = true;
      data.addIdeaBook = false;
    }
    this._vm.$cookies.set("ideaBook", state.ideaBookFlag, "1m");
    PatcraftApi.checkOutBasket(data)
      .then(res => {
        commit("currentCheckOutType", { results: data });
        commit("setBasketItem", { results: res.data });
      })
      .catch(() => {})
      .finally(() => {
        commit("updateLoader", false);
      });
  },
  fetchFullTypeSizeSamples({ commit }, data) {
    PatcraftApi.getFullTypeSizeSamples()
      .then(res => {
        commit("setFullTypeSizeSamples", { result: res.data });
      })
      .catch(() => {});
  },
  async addToCart({ dispatch }, data) {
    let self = this;
    await PatcraftApi.addToCart(data)
      .then(function(response) {
        dispatch("addLinkWithIndicator");
        let basketCount =
          response && response.data ? response.data.basketCount : null;
        dispatch("updateCartCountInHeader", basketCount);
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: "Basket updated",
            description: "Product added to your cart."
          },
          { root: true }
        );
        if (response && response.data && response.data.error)
          dispatch(
            "notifications/add",
            {
              type: "warning",
              title: "Basket updated",
              description: response.data.error
            },
            { root: true }
          );
        self._vm.$gtm.addToCartEvent(response?.data, 0);
      })
      .catch(function(error) {
        if(error?.response.data){
          dispatch(
            "notifications/add",
            {
              type: "error",
              title: "Error",
              description: error.response.data?.message?error.response.data.message: error.response.data
            },
            { root: true }
          );
        }
        else {
          dispatch(
            "notifications/add",
            {
              type: "error",
              title: "Error",
              description:
                "An error occurred when adding the product to your cart."
            },
            { root: true }
          );
        }
      });
  },
  updateCartCountInHeader({}, basketCount) {
    let type = 1;
    let cartCountElement = document.getElementsByClassName(
      "nav-top-customer-link-with-number-indicator"
    )[0];
    if (!cartCountElement) {
      type = 0;
      cartCountElement = document.getElementsByClassName(
        "nav-top-customer-link-with-number-indicator-empty"
      )[0];
    }

    if (basketCount > 0) {
      cartCountElement.classList.add(
        "nav-top-customer-link-with-number-indicator"
      );
      cartCountElement.classList.remove(
        "nav-top-customer-link-with-number-indicator-empty"
      );
    } else {
      cartCountElement.classList.add(
        "nav-top-customer-link-with-number-indicator-empty"
      );
      cartCountElement.classList.remove(
        "nav-top-customer-link-with-number-indicator"
      );
    }
    cartCountElement.innerHTML = basketCount;
  },
  addLinkWithIndicator() {
    let basketIcon = document.querySelector(
      "#header .nav-top-secondary-desktop .nav-top-customer-link-with-number-indicator-empty"
    );

    if (!basketIcon)
      // then it better be "nav-top-customer-link-with-number-indicator!!
      return;

    basketIcon.classList.replace(
      "nav-top-customer-link-with-number-indicator-empty",
      "nav-top-customer-link-with-number-indicator"
    );
  },
  async updateIdeaBookFlag({ commit, state, dispatch }, data) {
    if (data === false) {
      let item = state.basket.SiteItems.find(
        ({ VehicleId }) =>
          VehicleId == state.basket.LatestIdeaBook.IdeabookVehicleId
      );
      if (item && item.IsIdeaBook) {
        item.RequestAction = "remove";
        let removeData = {
          item: item,
          basketName: "SiteItems"
        };
        dispatch("postBasket", removeData);
      }
      this._vm.$cookies.set("ideaBook", data, "1m");
    }
    commit("setIdeaBookFlag", data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
